let portfolioData = {
    "firstname": "Rifa",
    "lastname": "Dayyan",
    "city": "Majalengka",
    "country": "Indonesia",
    "email":"rifadayyan@gmail.com",
    "aboutDescription": "Senior Web Developer specializing in backend and frontend development. Good problem solver, experienced with all stages of the development cycle for dynamic web projects. Enthusiastic about new technology and happy to learn new technology.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/rifa-dayyan-08130266",
          "className":"fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/rc4dayyan",
          "className":"fa-github"
        }
    ],
    "experiences":[
        {
            "title":"CO-FOUNDER & SENIOR WEB DEVELOPER",
            "companyName":"PT. CHRONOZ GLOBAL MEDIA, INDONESIA",
            "periode":"2015 to present",
            "description": [
                {
                    "descNote": "Develop project concepts and maintain optimal workflow.",
                },
                {
                    "descNote": "Complete detailed programming and development tasks for back end and front end public and internal websites.",
                },
                {
                    "descNote": "Carry out quality assurance tests to discover errors and optimize usability.",
                },
                {
                    "descNote": "Maintenance ichronoz system.",
                }            ]
        },
        {
            "title":"FREELANCER WEB DEVELOPER",
            "companyName":"SELF-EMPLOYED, INDONESIA",
            "periode":"2013 to present",
            "description": [
                
            ]
        },
        {
            "title":"WEB DEVELOPER",
            "companyName":"PT. METANOUVA, INDONESIA",
            "periode":"2010 to 2013",
            "description": [
                {
                    "descNote": "Worked as Junior Web Developer in this company. My role was to understand and execute the client's requirement in efficiently and timely manner.",
                }
            ]
        }
    ],
    "education":[
        {
            "school": "INDONESIAN EDUCATION UNIVERSITY",
            "areaStudy": "VOCATIONAL TECHNOLOGY EDUCATION",
            "gpa": "3.3",
            "periode": "2010-2013"
        },
        {
            "school": "PASUNDAN BANDUNG UNIVERSITY",
            "areaStudy": "INFORMATION TECHNOLOGY",
            "gpa": "3.13",
            "periode": "2005-2010"
        }
    ],
    "skills":{
        "highlight": [
            {
                "desc": "Strong decision maker"
            },
            {
                "desc": "Complex problem solver"
            },
            {
                "desc": "Innovative"
            },
            {
                "desc": "Service-focused"
            }
        ],
        "programLanguage": [
            {
                "name": "html",
                "classname": "fa-html5"
            },
            {
                "name": "css",
                "classname": "fa-css3-alt"
            },
            {
                "name": "javascript",
                "classname": "fa-js-square"
            },
            {
                "name": "PHP",
                "classname": "fa-php"
            },
            {
                "name": "angular",
                "classname": "fa-angular"
            },
            {
                "name": "react",
                "classname": "fa-react"
            },
            {
                "name": "wordpress",
                "classname": "fa-wordpress"
            },
            {
                "name": "npm",
                "classname": "fa-npm"
            }

        ]
    },
    "works":[
        {
            "title": "iChronoz Plugin Hotel Booking Engine (Frontend)",
            "tech": "Html, CSS, Javascript, ReactJs",
            "img": "plugin_be2.png",
            "desc": "Developed as a plugin for the chronoz booking engine"
        },
        {
            "title": "iChronoz Plugin Hotel Booking Engine (Frontend)",
            "tech": "Html, CSS, Javascript, AngularJs",
            "img": "plugin_be.png",
            "desc": "Developed as a plugin for the chronoz booking engine"
        },
        {
            "title": "iChronoz Hotel Booking Engine (Backend)",
            "tech": "Html, CSS, Javascript, PHP, Yii, Angular",
            "img": "booking_engine.jpg",
            "desc": "My contribution is developing backend, frontend and API integration for Channel manager, Payment gateway, Metasearch etc (https://ichronoz.net)"
        },
        {
            "title": "Safar24 Website",
            "tech": "Html, CSS, Javascript, PHP, Yii",
            "img": "safar24.png",
            "desc": "My contribution is developing backend and frontend (https://www.safar24.com)"
        },
        {
            "title": "Online registration system for JLPT",
            "tech": "Html, CSS, javascript, PHP, Wordpress",
            "img": "jlpt.jpg",
            "desc": "Client Goals:<br/>1. Through clear information can facilitate participants when registering <br/>2. Reducing questions and telephone / email that must be answered by the admin / organizer, especially for general matters that are often asked <br/> 3. Payment system automation reduces admin / organizer work for checking and validation <br/>4. Automating profile updates reduces admin / organizer work in updating participant data <br/><br/>My Contribution <br/>1. identify problems<br/>2. provide solutions to existing problems <br/>3. make registration flow <br/>4. implementation of flow with making an application from scratch <br/>(https://jlptonline.or.id)"
        },
        {
            "title": "School Profile",
            "tech": "Html, CSS, PHP, Wordpress",
            "img": "smkn1.jpg",
            "desc": "My client wants a School profile website with dynamic content that can be configured via the backend <br/> I built both of front-end and backend page using wordpress"
        },
        {
            "title": "Ramatour Travel Agent",
            "tech": "Html, CSS, PHP, Javascript, Yii",
            "img": "ramatour.jpg",
            "desc": "My contribution is developing backend system"
        }
    ],
  }
  
  export default portfolioData